import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ClockSvg from '../../../assets/icons/app/clock.svg?raw';

export const ClockIcon = (props) => <CustomSVG svg={ClockSvg} preserveColors appIconSmall {...props} />;
